import React, { useState } from 'react'
import { ButtonDropdown, DropdownMenu, DropdownToggle, Label } from 'reactstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { CloseIcon, FilterIcon, filterBlackIcon } from '../../assets/images';
import Select from "react-select";
import { ClientListType } from '../../screens/Scheduling/ScheduleReports/ClientJobScheduling';
import { CalenderIcon } from '../Icon';
import moment from 'moment';

type AppProps = {
  clientSelected: ClientListType;
  finalClientList: ClientListType[] | [];
  handleChangeClient: (data: any) => void;
  checkBottom: (data: any) => void;
  setLoadCondition: (data: boolean) => void;
  setText: (data: string) => void;
  setOffset: (data: number) => void;
  clientDirectoryFetching: boolean;
  onMenuClose: () => void;
  loadCondition: boolean;
  handleFilter: (type: string) => void;
  setClientSelected: (data: ClientListType) => void;
  filter: boolean;
  setFilter: (data: boolean) => void;
  setFilterStartDate: React.Dispatch<React.SetStateAction<string>>
  setFilterEndDate: React.Dispatch<React.SetStateAction<string>>
  filterStartDate:string;
  filterEndDate:string;
}


const AllClientsSopFilter = ({
  clientSelected,
  finalClientList,
  handleChangeClient,
  checkBottom,
  setLoadCondition,
  clientDirectoryFetching,
  onMenuClose,
  setText,
  setOffset,
  handleFilter,
  loadCondition,
  setClientSelected,
  filter,
  setFilter,
  filterStartDate,
  filterEndDate,
  setFilterEndDate,
  setFilterStartDate
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);

  const handleSubmit = () => {
    if ((!!clientSelected?.value || (filterStartDate && filterEndDate))) {
      handleFilter("add")
      setOffset(0);
    }
  };

  const filterEndDateChange = (date: any) => {
    if (date !== "Invalid date") {
        setFilterEndDate(date)
    }
    else {
        setFilterEndDate("")
    }
}
const filterStartDateChange = (date: any) => {
    if (date !== "Invalid date") {
        setFilterStartDate(date)
      
    }
    else {
        setFilterStartDate("")
        setFilterEndDate("")
    }
}

  const clearFilter = () => {
    setOffset(0);
    handleChangeClient("")
    setFilterStartDate("")
    setFilterEndDate("")
    setClientSelected({
      value: null,
      label: "Select Client...",
    })
    if (filter) {
      handleFilter("clear")
    }
    setFilter(false)
  };

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(!toggle);
        if (!filter) {
          setClientSelected({
            value: null,
            label: "Select..",
          })
          setFilterStartDate("")
          setFilterEndDate("")
          setFilter(false)
        }
      }}
    >
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 250 }}
        overlay={
          <Tooltip id="button-view-download-invoice">
            Filter
          </Tooltip>
        }
      >
        <DropdownToggle
          caret
          color="secondary"
          style={
            toggle || (!clientSelected?.value && (!filterStartDate || !filterEndDate))
              ? { border: "1px solid#bfcbe1" }
              : {
                color: "#dd4433",
                border: "1px solid #dd4433",
                backgroundColor: "#fff6f5",
              }
          }
          outline
        >
          <img src={toggle ? FilterIcon : filterBlackIcon} alt="" />

          {filter ? <span className={"filter-count"}><span>{(clientSelected?.value && filterStartDate && filterEndDate) ? 2 : 1}</span></span> : null}

        </DropdownToggle>
      </OverlayTrigger>
      <DropdownMenu right>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
                if (!filter) {
                  setClientSelected({
                    value: null,
                    label: "Select..",
                  })
                  setFilter(false)
                }
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />

          <div className="row mt-3">
                    <div className='d-flex'>
                        <div className="form-group col-md-6">
                            <div className='date-picker-wraper mr-0 position-relative'>
                                <Label className='mb-1 p-0 w-100' style={{ fontSize: "14px" }}> Start Date
                                <DatePicker
                                    dateFormat="dd-MM-yyyy"
                                    selected={filterStartDate ? new Date(moment(`${filterStartDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                    onChange={(e: any) => { filterStartDateChange(moment(e).format('YYYY-MM-DD')) }}
                                    fixedHeight
                                    showMonthDropdown
                                    showYearDropdown
                                    // onInputClick={()=>setText(choosefilterStartDate)}
                                    name='filterStartDate'
                                    placeholderText="Select"
                                    className='form-control'

                                />
                                <span className="calender-icon" style={{ top: "28px", right: '4px', cursor: 'pointer', position: "absolute" }}>
                                    <CalenderIcon />
                                </span>
                                </Label>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <div className='date-picker-wraper mr-0'>
                                    <Label className='mb-1 p-0 w-100' style={{ fontSize: "14px" }}> End Date
                                    <DatePicker
                                        dateFormat="dd-MM-yyyy"
                                        selected={filterEndDate ? new Date(moment(`${filterEndDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                        onChange={(e: any) => { filterEndDateChange(moment(e).format('YYYY-MM-DD')) }}
                                        fixedHeight
                                        showMonthDropdown
                                        showYearDropdown
                                        name='filterEndDate'
                                        placeholderText='Select'
                                        className='form-control'
                                        // disabled={!choosefilterStartDate}
                                        minDate={filterStartDate ? new Date(moment(`${filterStartDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                    />
                                    <span className="calender-icon" style={{ top: "28px", right: '20px', cursor: 'pointer' }}>
                                        <CalenderIcon />
                                        </span>
                                        </Label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


          <div className="mt-1 ml-1">
            <label className='mb-1'>Select Client</label>
            <div>
              <Select
                value={clientSelected}
                cacheOptions
                options={finalClientList}
                onChange={handleChangeClient}
                onMenuScrollToBottom={(e: any) => checkBottom(e)}
                onInputChange={(e: string) => {
                  setLoadCondition(false);
                  setText(e);
                  setOffset(0);
                }}
                onMenuClose={onMenuClose}
                isLoading={loadCondition && clientDirectoryFetching}
              />
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end p-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              handleSubmit();
              setToggle(!toggle);
            }}
            disabled={(!clientSelected?.value && (!filterStartDate || !filterEndDate))}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  )
}

export default AllClientsSopFilter
